import React from 'react';
import Feature1 from '../../assets/images/icon/satisfaction-guarantee.png';
import Feature2 from '../../assets/images/icon/professional-team.png';
import Feature3 from '../../assets/images/icon/material-instrument.png';
import Feature4 from '../../assets/images/icon/experience.png';

const Feature = () => {
    return (
        <>
            <div className="features-area bg-white pt-110 pb-110">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <div className="single-feature text-center box-shadow-3">
                                <div className="single-feature-icon">
                                    <img src={Feature1} alt="" />
                                </div>
                                <h5>Satisfaction Guarantee </h5>
                                <p> At Bright Sun, we take pride in delivering exceptional results—every time. Our satisfaction guarantee ensures we’ll redo any service that doesn’t meet your expectations, because your peace of mind is our top priority. </p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <div className="single-feature text-center box-shadow-3">
                                <div className="single-feature-icon">
                                    <img src={Feature2} alt="" />
                                </div>
                                <h5>Professional Team</h5>
                                <p> Our skilled technicians are fully trained, background-checked, and dedicated to excellence. With industry expertise and attention to detail, we treat your space with the care it deserves.</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <div className="single-feature text-center box-shadow-3">
                                <div className="single-feature-icon">
                                    <img src={Feature3} alt="" />
                                </div>
                                <h5>Premium Equipment & Materials </h5>
                                <p> We use only commercial-grade tools and eco-friendly products designed for superior results. From non-toxic cleaners to precision gardening tools, quality is built into every service.</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6">
                            <div className="single-feature text-center box-shadow-3">
                                <div className="single-feature-icon">
                                    <img src={Feature4} alt="" />
                                </div>
                                <h5>5 Years Experience</h5>
                                <p> Five Years of experience have taught us how to deliver consistent, reliable care for Ottawa homes and businesses. When you choose Bright Sun, you’re choosing proven expertise</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Feature;